import { Component  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Status } from "../../models/interfaces/status.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-expenses_add",
  templateUrl: "expenses_add.html",
})

export class ExpensesAddPage {
  private settings$: any;
  private loading: any;
  private status$;
  private expensesForm: FormGroup;

  private setting: any;
  private ex_qty: number;
  private hl_id: number;
  private ex_amount: number;
  private ex_rate: number;
  private se_order: number;
  private ex_date: string = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate() + 1).toISOString().substring(0, 10);
  private styleName: string ="";

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController,
  ) {
    console.log("ExpensesAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.hl_id = this.navParams.data.expenses[0].hl_id ;
    this.ex_date = this.navParams.data.expenses[0].hl_datetime ;
    this.ex_qty = 1;
    this.expensesForm = this.formBuilder.group({
      "se_id": ["", [Validators.required]],
      "se_order": [""],
      "ex_date": [this.ex_date, [Validators.required]],
      "hl_id": [this.hl_id],
      "ex_remark": [""],
      "ex_qty": [this.ex_qty, [Validators.required]],
      "ex_rate": [""],
      "ex_amount": [""],
    });
  }
  private ionViewWillEnter() {
    console.log("ExpensesAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("ExpensesAddPage onInitPage");

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class='Expenses' order by se_order",
    }).subscribe((ret) => {
      this.settings$ = ret;
    });
  }

  private onInput_ex_qty(_ex_qty) {
    console.log("ExpensesAddPage onInput_pl_qty");
    this.ex_qty = _ex_qty;
    this.ex_amount = this.ex_rate * this.ex_qty;
  }

  private changeSelect_item(_se_id) {
    console.log("ExpensesAddPage changeSelect_se_name", _se_id);
    console.log("PledgeAddPage settings$", this.settings$);

    this.setting = this.settings$.filter(
      (setting) => setting.se_id === _se_id);
    this.se_order = this.setting[0].se_order;
    this.ex_rate = this.setting[0].se_key_value;
    this.ex_amount = this.setting[0].se_key_value * this.ex_qty;
  }

  private goback() {
    console.log("ExpensesAddPage goback");
    this.navCtrl.pop();
  }

  private addExpenses(value: any) {
    console.log("ExpensesAddPage addExpenses");

    const formValues: any = {
      "ex_amount": value.ex_amount,
      "ex_date": value.ex_date,
      "ex_qty": value.ex_qty,
      "ex_rate": value.ex_rate,
      "ex_remark": value.ex_remark,
      "hl_id": this.hl_id,
      "se_id": value.se_id,
      "se_order": this.se_order,
    };

     this.db.dbCol({ "action": "insert", "mapObject": "expenses", ...formValues })
      .subscribe((ret) => {
        this.navCtrl.pop();
      },
    );
  }

  private ngOnDestroy() {
    console.log("ExpensesAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/expenses/expenses_add.ts